import React, {useContext, useEffect, useState} from 'react';
import {BoShowContext} from "../context/bo-show-context.jsx";
import {BoKeys} from "../../resources/bo-keys.js";

const IMAGE_EXTENSIONS = ['jpg', 'jpeg', "jfif", "JFIF", 'png', 'image/jpg', 'image/jpeg', 'image/png', 'image/jfif'];

const BoShowFullImage = () => {
    const {boData, printOptions, verifySyncUrl, attachesToHide} = useContext(BoShowContext);

    const [attaches, setAttaches] = useState([])

    useEffect(() => {
        if (!boData) return;

        setAttaches(() => {
            const newAttaches = [];

            boData?.individualList?.forEach(i => {
                const relatedPhotoFace = i.attachs?.find(a => a.attachId === i.relatedPhotoFaceId);
                const documentPhoto = i.attachs?.find(a => a.attachId === i.documentPhotoId);

                if (relatedPhotoFace) {
                    newAttaches.push({
                        attachId: relatedPhotoFace.attachId,
                        src: verifySyncUrl(relatedPhotoFace.attachId) + "/" + relatedPhotoFace.attachId,
                        title: "INDIVÍDUO - " + i.itemId + " - Foto da face",
                        extension: relatedPhotoFace.extension
                    })
                }

                if (documentPhoto) {
                    newAttaches.push({
                        attachId: documentPhoto.attachId,
                        src: verifySyncUrl(documentPhoto.attachId) + "/" + documentPhoto.attachId,
                        title: "INDIVÍDUO - " + i.itemId + " - Documento",
                        extension: documentPhoto.extension
                    })
                }
            });

            boData?.apprehensionList?.filter((item) => !item?.relatedVehicle).forEach((a, index) => {
                const attachment = a?.attachs?.[0];
                if (attachment && attachment?.attachId) {
                    newAttaches.push({
                        attachId: attachment.attachId,
                        src: verifySyncUrl(attachment.attachId) + "/" + attachment.attachId,
                        title: "APREENSÃO - " + (index + 1),
                        extension: attachment.extension
                    })
                }
            })

            boData?.stolenItemList?.forEach((a, index) => {
                const attachment = a?.attachs?.[0];
                if (attachment && attachment?.attachId) {
                    newAttaches.push({
                        attachId: attachment.attachId,
                        src: verifySyncUrl(attachment.attachId) + "/" + attachment.attachId,
                        title: "ITEM SUBTRAÍDO - " + (index + 1),
                        extension: attachment.extension
                    })
                }
            })

            boData?.vehicleList?.forEach((i, index) => {
                const documentPhoto = i.attachs?.find(a => a.attachId === i.documentPhotoId);

                if (documentPhoto) {
                    newAttaches.push({
                        attachId: documentPhoto.attachId,
                        src: verifySyncUrl(documentPhoto.attachId) + "/" + documentPhoto.attachId,
                        title: "VEÍCULO - " + (index + 1) + " - Documento",
                        extension: documentPhoto.extension
                    })
                }

                i?.attachs?.filter((attach) => attach?.attachId !== i?.documentPhotoId).forEach((a, i) => {
                    newAttaches.push({
                        attachId: a.attachId,
                        src: verifySyncUrl(a.attachId) + "/" + a.attachId,
                        title: "VEÍCULO - " + (index + 1) + " - Fotos do veículo - " + (i + 1),
                        extension: a.extension
                    })
                })
            });

            boData?.croqui?.attachs?.forEach(a => {
                newAttaches.push({
                    attachId: a.attachId,
                    src: verifySyncUrl(a.attachId) + "/" + a.attachId,
                    title: "CROQUI E FOTOS" + (!!a.description ? " - " + a.description : ""),
                    extension: a.extension
                })
            })

            boData?.otherDocumentsList?.forEach((d, i) => {
                d.attachs?.forEach(a => {
                    newAttaches.push({
                        attachId: a.attachId,
                        src: verifySyncUrl(a.attachId) + "/" + a.attachId,
                        title: "DOCUMENTO - " + (d?.type ? BoKeys[d.type] ?? d.type : '') + " " + d.value,
                        extension: a.extension
                    })
                })
            })

            return newAttaches;
        })
    }, [boData]);

    return (
        <article className={"hidden" + (printOptions.attachFullSize ? " print:block" : "")}>
            {
                attaches.filter(a => !attachesToHide.includes(a.attachId) && (!a.extension || IMAGE_EXTENSIONS.includes(a.extension))).map((a, index) => (
                    <section className={"break-before-page space-y-4"} key={"a-full-" + index}>
                        <h2 className={"resume-title"}>{a.title}</h2>

                        <div className={"flex flex-col items-center justify-center"}>
                            <img className={"!max-h-[1280px] !max-w-[900px]"} src={a.src} alt={a.title}/>
                        </div>
                    </section>
                ))
            }
        </article>
    );
};

export default BoShowFullImage;